export default {
  campaign: state => state.campaign,
  campaigns: state => state.campaigns,
  registrants: state => state.registrants,
  currentCampaignId: state => state.currentCampaignId,
  isNew: state => state.isNew,
  isTemplate: state => state.isTemplate,
  inviting: state => state.inviting,
  translations: state => state.translations,
  selectedLanguage: state => state.selectedLanguage,
  languages() {
    return [
      'ENG',
      'EST',
      'RUS',
      'BUL',
      'LAV',
      'LTU',
      'HUN',
      'CZE',
      'UKR',
      'POL',
      'FIN'
    ]
  }
}
